import { useEffect, useRef } from 'react';

const instagramPosts = [
  {
    src: 'https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/acb0ecdccaa8f297ddefe7cd39434681.png',
    link: 'https://www.instagram.com/p/DavG35RxU-7/',
  },
  {
    src: 'https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/ac044d0535053c4abbe1dfc46858703c.png',
    link: 'https://www.instagram.com/p/DbI67mkRBJ0/',
  },
  {
    src: 'https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/3f83157c5feafcd135c54cac0cace0ec.png',
    link: 'https://www.instagram.com/p/Da8Pb24RI1w/',
  },
  {
    src: 'https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/e2db21960a60df1ab73915c7d9cd7036.png',
    link: 'https://www.instagram.com/p/DaBvD1Oujfp/',
  },
  {
    src: 'https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/54937b9b4955a879bfd6342fc1f71240.png',
    link: 'https://www.instagram.com/p/DaVaUwpRwQm/',
  },
  {
    src: 'https://static.readdy.ai/image/5ae0a0be7c3b05867c1dbd14bfaff312/334b69692120f0936d08056e8d934e86.png',
    link: 'https://www.instagram.com/p/Da22kK-xMBV/',
  },
];

const InstagramSection = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.querySelectorAll('.reveal').forEach((el) => {
              el.classList.add('revealed');
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="instagram"
      ref={sectionRef}
      className="relative py-20 md:py-28 bg-background-100 overflow-hidden"
    >
      {/* Decorative blob */}
      <div className="absolute top-[-100px] right-[-100px] w-[400px] h-[400px] rounded-full bg-accent-50/30" />

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="reveal inline-flex items-center gap-2 font-label text-xs md:text-sm text-accent-600 tracking-widest uppercase mb-4">
              <span className="w-6 h-px bg-accent-400" />
              Siga-nos
              <span className="w-6 h-px bg-accent-400" />
            </span>
            <h2 className="reveal reveal-delay-1 font-display text-3xl md:text-5xl text-foreground-900 leading-tight mb-4">
              @naturallesanduiches
            </h2>
            <p className="reveal reveal-delay-2 font-body text-base text-foreground-500">
              Acompanhe nosso dia a dia e novidades no Instagram.
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-3 md:grid-cols-6 gap-2 md:gap-3 mb-8 md:mb-10">
            {instagramPosts.map((post, index) => (
              <a
                key={index}
                href={post.link}
                target="_blank"
                rel="noopener noreferrer"
                className={`reveal aspect-square rounded-xl md:rounded-2xl overflow-hidden group relative`}
                style={{ transitionDelay: `${index * 0.08}s` }}
              >
                <img
                  src={post.src}
                  alt={`Naturalle Instagram ${index + 1}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-background-50/0 group-hover:bg-background-50/50 transition-colors duration-300 flex items-center justify-center">
                  <i className="ri-instagram-line text-2xl text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
              </a>
            ))}
          </div>

          <div className="reveal text-center">
            <a
              href="https://www.instagram.com/naturallesanduiches/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 font-label text-sm px-7 py-3.5 rounded-full border border-foreground-200 text-foreground-700 hover:border-accent-400 hover:text-accent-600 transition-all duration-300"
            >
              <i className="ri-instagram-line" />
              <span>Seguir no Instagram</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InstagramSection;